// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__5EIjr","inputWrap":"CustomTip_inputWrap__2_Cl6"};